import { Component } from '@angular/core';

@Component({
  selector: 'app-painting-equipment',
  templateUrl: './painting-equipment.component.html',
  styleUrls: ['./painting-equipment.component.scss']
})
export class PaintingEquipmentComponent {
  
  advanceMoullding:any[] = [
    {
      title: 'Manual Spray Guns​',
      img: 'assets/images/capability/white/painting_equipment_1.JPG',
    },
    {
      title: 'Auto Spray Guns​​',
      img: 'assets/images/capability/white/painting_equipment_2.JPG',
    },
    {
      title: 'Electrostatic Painting Equipment​',
      img: 'assets/images/capability/white/painting_equipment_3.JPG',
    },
    {
      title: 'Painting Robots​​',
      img: 'assets/images/capability/white/painting_equipment_4.JPG',
    },
    {
      title: 'Paint Circulation System',
      img: 'assets/images/capability/white/painting_equipment_5.JPG',
    },
    {
      title: 'Turnkey Paint Shop​',
      img: 'assets/images/capability/white/painting_equipment_6.JPG',
    },
    {
      title: '2k Mixer​​',
      img: 'assets/images/capability/white/painting_equipment_7.JPG',
    },
    {
      title: 'Accessories​​',
      img: 'assets/images/capability/white/painting_equipment_8.JPG',
    },
  ]

}
